import { 
  Component, 
  Input
} from '@angular/core';
import { 
  NavController
} from 'ionic-angular';
import moment from 'moment';

// Providers
import { RecertificationService } from '../../../providers/instructors/recertification-service';

// Pages
import { RecertificationViewPage } from '../../../pages/recertifications/recertification-view';

@Component({
  selector: 'dashboard-count-recertification',
  templateUrl: 'dashboard-count-recertification.component.html'
})

export class DashboardCountRecertificationComponent
{
  @Input() color: string;
  @Input() label: string;
  @Input() status: string;

  recertifications: any = [];
  count: number = 0;

  constructor(
    public recertificationService: RecertificationService,
    public navCtrl: NavController
  )
  {
    setTimeout(() => {
      this.getRecertifications();    
    }, 500);
  }

  getRecertifications()
  {
    this.recertificationService.getRecertificationsByStatus( this.status ).subscribe( data => {
      this.recertifications = data;
      this.count = this.recertifications.length;
    });
  }

  showRecertificationViewPage( recertification = null )
  {
    this.navCtrl.push( RecertificationViewPage, {
      recertification: recertification
    });
  }

  ngOnInit()
  {
    //this.getInstructors();  
  }
}  


// WEBPACK FOOTER //
// ./src/pages/dashboard/components/dashboard-count-recertification.component.ts